<div class="organizer-categorize-main" data-cy="organizer-categorize-container">
  <div class="standard-dialog-header" data-cy="organizer-categorize-header">Categorize</div>
  <div class="standard-dialog-content" style="flex: 1; display: flex; max-height: 100%;" data-cy="organizer-categorize-content">
    <div class="image-container" data-cy="organizer-images-container">
      <div class="item" *ngFor="let doc of dataModel.documents" data-cy="organizer-document-item">
        <div style="border: 1px solid #333333; border-radius: var(--border-radius);" data-cy="organizer-document-image-container">
          <img [alt]="doc.DocumentFileName" [src]="getDocumentUrl(doc)" data-cy="organizer-document-image">
        </div>
        <div class="category-pills" style="max-width: 250px; margin-left: 0; margin-right: 0;" data-cy="organizer-category-pills-container">
          <div *ngFor="let tag of doc.dataDocumentTags" class="pill" style="margin-left: 0; margin-right: 2px; padding-right: 2px; background-color: #333333; border: 1px solid var(--tdo-primary-accent); color: white; display: flex; height: 30px; font-size: 14px; flex-basis: fit-content; min-width: fit-content;" data-cy="organizer-category-pill">
            {{tag.enumDocumentTag.ItemDisplayValue}}
            <div style="display: flex; flex-wrap: wrap; margin-left: 8px; position: relative; top: 2px; right: 0; font-size: 24px; cursor: pointer; width: fit-content; color: var(--tdo-primary-accent);">
              <mat-icon (click)="onDeleteDocumentTag(doc, tag)" data-cy="organizer-category-delete-icon">highlight_off</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="flex-basis: 426px; min-width: 428px; max-height: 100%; border-radius: var(--border-radius); padding-left: 6px; display: flex; flex-direction: column; overflow-y: hidden;" data-cy="organizer-categories-panel">
      <div #cont style="flex: 1; width: 100%; height: 100%; max-height: 100%; overflow-y: hidden" data-cy="organizer-categories-container">
        <app-imaging-categories-menu style="flex: 1; max-height: calc(100% - 60px); overflow-y: hidden; position: relative; top: -40px;"
                                     (categoriesSelected)="onTagsAdded($event)"
                                     [height]="cont.getBoundingClientRect().height + 'px'"
                                     [isStaticMode]="true"
                                     data-cy="organizer-categories-menu"></app-imaging-categories-menu>
      </div>
      <!--<div style="flex-basis: fit-content; font-weight: 500;">Categories</div>
      <div style="flex-basis: 100%;">
        <div style="height: 450px; overflow-y: auto; overflow-x: hidden;">
          <div style="margin-right: 6px; height: 22px;" *ngFor="let option of dataModel.documentTagOptions">
            <mat-checkbox (change)="onCheckboxChange($event, option)" style="height: 10px;">{{option.ItemDisplayValue}}</mat-checkbox>
          </div>
        </div>
      </div>
      <div style="flex-basis: 60px;">
        <div style="display: flex; width: fit-content; margin-left: auto; margin-right: 8px; margin-top: 10px;">
          <button [disabled]="isAnyNewTags" (click)="onApply()" class="tdo-button tdo-save" style="margin-right: 6px;">
            Apply
          </button>
          <div (click)="onCancel()" class="tdo-button tdo-close" style="margin-left: 16px;">
            Close
          </div>
        </div>
      </div>-->
    </div>
  </div>
  <div style="flex-basis: 60px; overflow: hidden;" data-cy="organizer-categorize-actions">
    <div style="display: flex; width: fit-content; margin-left: auto; margin-top: 10px; margin-right: 6px;">
      <button [disabled]="isAnyNewTags" (click)="onApply()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="organizer-apply-button">
        Apply
      </button>
      <div (click)="onCancel()" class="tdo-button tdo-close" style="margin-left: 6px;" data-cy="organizer-close-button">
        Close
      </div>
    </div>
  </div>
</div>
